/*
 * HUBFF · Apps do site: wishlist (favoritos) e avaliações com fotos.
 * Os dados ficam no HUBFF (window.HUBFF_SITE.api, ver snippets/hubff-site-apps.liquid).
 * - Wishlist: sem login fica no navegador (localStorage); logada, vai pro HUBFF e,
 *   quando ela entra na conta, a lista do navegador é juntada à da conta.
 * - Avaliações: lista só as aprovadas no HUBFF; o envio entra pendente.
 * Texto de cliente é sempre inserido com textContent (nunca innerHTML).
 */
(function () {
  'use strict';
  var CFG = window.HUBFF_SITE || {};
  if (!CFG.api) return;
  var API = String(CFG.api).replace(/\/+$/, '');
  var LOJA = CFG.loja || 'fio-a-fio-beach';
  var CLI = CFG.cliente || null;

  // ─── utilitários ──────────────────────────────────────────────────────────
  function el(tag, attrs, filhos) {
    var n = document.createElement(tag);
    if (attrs) Object.keys(attrs).forEach(function (k) {
      var v = attrs[k];
      if (v == null || v === false) return;
      if (k === 'text') n.textContent = v;
      else if (k === 'class') n.className = v;
      else if (k.slice(0, 2) === 'on') n.addEventListener(k.slice(2), v);
      else n.setAttribute(k, v === true ? '' : v);
    });
    (filhos || []).forEach(function (f) { if (f) n.appendChild(typeof f === 'string' ? document.createTextNode(f) : f); });
    return n;
  }
  function qs(o) { return Object.keys(o).filter(function (k) { return o[k] != null && o[k] !== ''; }).map(function (k) { return encodeURIComponent(k) + '=' + encodeURIComponent(o[k]); }).join('&'); }
  function lsGet(k, def) { try { var v = localStorage.getItem(k); return v ? JSON.parse(v) : def; } catch (e) { return def; } }
  function lsSet(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) { /* modo privado */ } }
  function lsDel(k) { try { localStorage.removeItem(k); } catch (e) { /* */ } }
  function dataBR(iso) { try { return new Date(iso).toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric' }); } catch (e) { return ''; } }
  function postJson(path, body) {
    // text/plain evita o preflight de CORS; o HUBFF lê o JSON do corpo.
    return fetch(API + path, { method: 'POST', headers: { 'Content-Type': 'text/plain;charset=UTF-8' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().catch(function () { return {}; }).then(function (j) { if (!r.ok) throw new Error(j.error || 'Não deu pra salvar agora.'); return j; }); });
  }
  var toastT;
  function toast(msg) {
    var t = document.querySelector('.hubff-toast') || document.body.appendChild(el('div', { class: 'hubff-toast', role: 'status', 'aria-live': 'polite' }));
    t.textContent = msg; t.classList.add('is-visible');
    clearTimeout(toastT); toastT = setTimeout(function () { t.classList.remove('is-visible'); }, 4200);
  }
  var SVG_NS = 'http://www.w3.org/2000/svg';
  function estrela(cheia) {
    var s = document.createElementNS(SVG_NS, 'svg'); s.setAttribute('viewBox', '0 0 24 24'); s.setAttribute('aria-hidden', 'true');
    s.setAttribute('class', 'hubff-star' + (cheia === 1 ? ' is-full' : cheia > 0 ? ' is-half' : ''));
    var p = document.createElementNS(SVG_NS, 'path'); p.setAttribute('d', 'M12 2.5l2.94 6.1 6.56.86-4.8 4.62 1.2 6.52L12 17.4l-5.9 3.2 1.2-6.52-4.8-4.62 6.56-.86z');
    s.appendChild(p); return s;
  }
  function estrelas(nota) {
    var w = el('span', { class: 'hubff-stars', role: 'img', 'aria-label': (nota || 0).toLocaleString('pt-BR') + ' de 5 estrelas' });
    for (var i = 1; i <= 5; i++) w.appendChild(estrela(nota >= i ? 1 : nota > i - 1 ? 0.5 : 0));
    return w;
  }

  // ─── WISHLIST ─────────────────────────────────────────────────────────────
  var LS_VISITANTE = 'hubff_wl_v1';   // [{p, h, v, a}] de quem não está logada
  var LS_CONTA = 'hubff_wl_conta_v1'; // espelho da lista da conta (pinta os corações sem esperar o HUBFF)
  var itens = [];

  function credenciais() { return { loja: LOJA, c: CLI.c, e: CLI.e, t: CLI.t, n: CLI.n || '' }; }
  function setText(n, v) { if (n.textContent !== v) n.textContent = v; }

  function pintar() {
    var ids = {};
    itens.forEach(function (i) { ids[i.p] = true; });
    document.querySelectorAll('[data-hubff-wl]').forEach(function (b) {
      var on = !!ids[b.getAttribute('data-hubff-wl')];
      if (b.classList.contains('is-active') !== on) b.classList.toggle('is-active', on);
      if (b.getAttribute('aria-pressed') !== String(on)) b.setAttribute('aria-pressed', String(on));
      var rotulo = on ? 'Remover dos favoritos' : 'Adicionar aos favoritos';
      if (b.getAttribute('aria-label') !== rotulo) { b.setAttribute('aria-label', rotulo); b.setAttribute('title', rotulo); }
      var t = b.querySelector('.hubff-wl-btn__txt');
      if (t) setText(t, on ? 'Favoritado' : 'Favoritar');
    });
    document.querySelectorAll('[data-hubff-wl-count]').forEach(function (c) {
      setText(c, String(itens.length));
      if (c.hidden !== !itens.length) c.hidden = !itens.length;
    });
  }
  function avisar() { pintar(); document.dispatchEvent(new CustomEvent('hubff:wishlist', { detail: { itens: itens.slice() } })); }
  function daConta(lista) {
    itens = (lista || []).map(function (i) { return { p: i.productId, h: i.handle, v: i.variantId, a: i.addedAt }; });
    lsSet(LS_CONTA, itens); avisar();
  }

  function iniciarWishlist() {
    if (CLI) {
      itens = lsGet(LS_CONTA, []); avisar();
      var doNavegador = lsGet(LS_VISITANTE, []);
      var req = doNavegador.length
        ? postJson('/wishlist', Object.assign(credenciais(), { acao: 'sync', itens: doNavegador.map(function (g) { return { productId: g.p, variantId: g.v }; }) }))
          .then(function (j) { lsDel(LS_VISITANTE); return j; })
        : fetch(API + '/wishlist?' + qs(credenciais())).then(function (r) { if (!r.ok) throw new Error('wishlist ' + r.status); return r.json(); });
      req.then(function (j) { daConta(j.itens); }).catch(function () { /* fica o espelho local */ });
    } else {
      lsDel(LS_CONTA); // saiu da conta: o navegador não mostra mais a lista dela
      itens = lsGet(LS_VISITANTE, []); avisar();
    }
  }

  function alternar(btn) {
    var p = btn.getAttribute('data-hubff-wl');
    if (!p) return;
    var tem = itens.some(function (i) { return i.p === p; });
    var antes = itens.slice();
    itens = tem ? itens.filter(function (i) { return i.p !== p; })
      : [{ p: p, h: btn.getAttribute('data-handle') || '', v: btn.getAttribute('data-variant') || null, a: new Date().toISOString() }].concat(itens);
    avisar();
    if (!tem) { btn.classList.remove('is-pop'); void btn.offsetWidth; btn.classList.add('is-pop'); }
    if (!CLI) {
      lsSet(LS_VISITANTE, itens);
      if (!tem && !lsGet('hubff_wl_aviso', false)) { lsSet('hubff_wl_aviso', true); toast('Salvo nos favoritos deste navegador. Entre na sua conta pra ver de qualquer lugar.'); }
      return;
    }
    postJson('/wishlist', Object.assign(credenciais(), { acao: tem ? 'remove' : 'add', productId: p, variantId: btn.getAttribute('data-variant') || null }))
      .then(function (j) { daConta(j.itens); })
      .catch(function (e) { itens = antes; avisar(); toast(e.message); });
  }

  // Captura: o clique no coração não pode abrir o produto nem o quick add do card.
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('[data-hubff-wl]') : null;
    if (!b) return;
    e.preventDefault(); e.stopPropagation();
    alternar(b);
  }, true);

  // Cards que entram depois (filtros, carregar mais, recomendações): repinta.
  var obsT;
  new MutationObserver(function () { clearTimeout(obsT); obsT = setTimeout(pintar, 150); }).observe(document.documentElement, { childList: true, subtree: true });

  // Página "Meus favoritos": cada produto vira o card do próprio tema (Section Rendering API).
  function paginaFavoritos(root) {
    var grid = root.querySelector('[data-hubff-wl-grid]');
    var vazio = root.querySelector('[data-hubff-wl-vazio]');
    var login = root.querySelector('[data-hubff-wl-login]');
    if (login) login.hidden = !!CLI;
    function render() {
      var lista = itens.filter(function (i) { return i.h; });
      if (vazio) vazio.hidden = lista.length > 0;
      Array.prototype.slice.call(grid.children).forEach(function (c) {
        if (!lista.some(function (i) { return i.p === c.getAttribute('data-p'); })) c.remove();
      });
      lista.forEach(function (i) {
        if (grid.querySelector('[data-p="' + i.p + '"]')) return;
        var slot = el('div', { class: 'hubff-wl-page__item is-loading', 'data-p': i.p });
        grid.appendChild(slot);
        fetch('/products/' + encodeURIComponent(i.h) + '?section_id=hubff-wishlist-card')
          .then(function (r) { if (!r.ok) throw new Error(String(r.status)); return r.text(); })
          .then(function (html) { slot.innerHTML = html; slot.classList.remove('is-loading'); pintar(); })
          .catch(function () { slot.remove(); });
      });
    }
    document.addEventListener('hubff:wishlist', render);
    render();
  }

  // ─── AVALIAÇÕES ───────────────────────────────────────────────────────────
  var CAIMENTO = { pequeno: 'Ficou pequeno', ideal: 'Tamanho ideal', grande: 'Ficou grande' };

  function lightbox(fotos, inicio) {
    var idx = inicio || 0;
    var img = el('img', { class: 'hubff-lb__img', alt: 'Foto de cliente' });
    var cont = el('span', { class: 'hubff-lb__count' });
    function mostrar() { img.src = fotos[idx].url; cont.textContent = fotos.length > 1 ? (idx + 1) + ' / ' + fotos.length : ''; }
    function fechar() { ov.remove(); document.removeEventListener('keydown', tecla); document.documentElement.classList.remove('hubff-no-scroll'); }
    function passo(d) { idx = (idx + d + fotos.length) % fotos.length; mostrar(); }
    function tecla(e) { if (e.key === 'Escape') fechar(); else if (e.key === 'ArrowRight') passo(1); else if (e.key === 'ArrowLeft') passo(-1); }
    var ov = el('div', { class: 'hubff-lb', role: 'dialog', 'aria-modal': 'true', 'aria-label': 'Fotos das clientes', onclick: function (e) { if (e.target === ov) fechar(); } }, [
      el('button', { class: 'hubff-lb__close', type: 'button', 'aria-label': 'Fechar', text: '×', onclick: fechar }),
      fotos.length > 1 ? el('button', { class: 'hubff-lb__nav hubff-lb__nav--prev', type: 'button', 'aria-label': 'Foto anterior', text: '‹', onclick: function () { passo(-1); } }) : null,
      img,
      fotos.length > 1 ? el('button', { class: 'hubff-lb__nav hubff-lb__nav--next', type: 'button', 'aria-label': 'Próxima foto', text: '›', onclick: function () { passo(1); } }) : null,
      cont,
    ]);
    document.body.appendChild(ov); document.documentElement.classList.add('hubff-no-scroll');
    document.addEventListener('keydown', tecla);
    mostrar();
  }

  function miniaturas(fotos, classe) {
    return el('div', { class: classe }, fotos.map(function (f, i) {
      return el('button', { type: 'button', class: 'hubff-rv-thumb', 'aria-label': 'Ampliar foto', onclick: function () { lightbox(fotos, i); } },
        [el('img', { src: f.url, alt: '', loading: 'lazy', width: f.w, height: f.h })]);
    }));
  }

  function itemAvaliacao(a) {
    var topo = el('div', { class: 'hubff-rv-item__top' }, [
      estrelas(a.nota),
      el('span', { class: 'hubff-rv-item__autor', text: a.autor }),
      a.verificada ? el('span', { class: 'hubff-rv-badge', text: '✓ Compra verificada' }) : null,
      el('time', { class: 'hubff-rv-item__data', datetime: a.data, text: dataBR(a.data) }),
    ]);
    var meta = [a.tamanho ? 'Tamanho ' + a.tamanho : '', a.caimento ? CAIMENTO[a.caimento] || '' : ''].filter(Boolean).join(' · ');
    return el('article', { class: 'hubff-rv-item' }, [
      topo,
      a.titulo ? el('h3', { class: 'hubff-rv-item__titulo', text: a.titulo }) : null,
      el('p', { class: 'hubff-rv-item__texto', text: a.texto }),
      meta ? el('p', { class: 'hubff-rv-item__meta', text: meta }) : null,
      a.fotos && a.fotos.length ? miniaturas(a.fotos, 'hubff-rv-item__fotos') : null,
      a.resposta ? el('div', { class: 'hubff-rv-item__resposta' }, [el('strong', { text: 'Resposta da Fio a Fio' }), el('p', { text: a.resposta })]) : null,
    ]);
  }

  function resumoAvaliacoes(r) {
    var barras = el('div', { class: 'hubff-rv-dist' }, [5, 4, 3, 2, 1].map(function (n) {
      var q = r.distribuicao[n] || 0, pct = r.total ? Math.round((q / r.total) * 100) : 0;
      var barra = el('span', { class: 'hubff-rv-dist__bar' }, [el('span', { style: 'width:' + pct + '%' })]);
      return el('div', { class: 'hubff-rv-dist__row' }, [el('span', { text: n + '★' }), barra, el('span', { class: 'hubff-rv-dist__n', text: String(q) })]);
    }));
    var fit = r.caimento || {}, totFit = (fit.pequeno || 0) + (fit.ideal || 0) + (fit.grande || 0);
    var caimento = null;
    if (totFit) {
      var pct = function (k) { return Math.round(((fit[k] || 0) / totFit) * 100); };
      caimento = el('div', { class: 'hubff-rv-fit' }, [
        el('p', { class: 'hubff-rv-fit__titulo', text: 'Caimento' }),
        el('div', { class: 'hubff-rv-fit__bar' }, ['pequeno', 'ideal', 'grande'].map(function (k) { return el('span', { class: 'is-' + k, style: 'width:' + pct(k) + '%' }); })),
        el('p', { class: 'hubff-rv-fit__legenda', text: 'Pequeno ' + pct('pequeno') + '% · Ideal ' + pct('ideal') + '% · Grande ' + pct('grande') + '%' }),
      ]);
    }
    return el('div', { class: 'hubff-rv-resumo' }, [barras, caimento]);
  }

  // Foto de celular pode passar de 10 MB: reduz pra 1600 px em JPEG antes de mandar (o HUBFF regrava e tira o GPS).
  function reduzir(file) {
    return new Promise(function (ok) {
      var url = URL.createObjectURL(file), img = new Image();
      img.onload = function () {
        var k = Math.min(1, 1600 / Math.max(img.naturalWidth, img.naturalHeight));
        var c = document.createElement('canvas');
        c.width = Math.round(img.naturalWidth * k); c.height = Math.round(img.naturalHeight * k);
        c.getContext('2d').drawImage(img, 0, 0, c.width, c.height);
        c.toBlob(function (b) { URL.revokeObjectURL(url); ok(b ? new File([b], 'foto.jpg', { type: 'image/jpeg' }) : file); }, 'image/jpeg', 0.86);
      };
      img.onerror = function () { URL.revokeObjectURL(url); ok(file); };
      img.src = url;
    });
  }

  function formulario(root, produtoId, produtoTitulo, tamanhos, aoEnviar) {
    var fotos = [];
    var erro = el('p', { class: 'hubff-rv-form__erro', role: 'alert' });
    var previews = el('div', { class: 'hubff-rv-form__previews' });
    function desenharPreviews() {
      previews.textContent = '';
      fotos.forEach(function (f, i) {
        var u = URL.createObjectURL(f);
        previews.appendChild(el('div', { class: 'hubff-rv-form__preview' }, [
          el('img', { src: u, alt: '' }),
          el('button', { type: 'button', 'aria-label': 'Tirar foto', text: '×', onclick: function () { URL.revokeObjectURL(u); fotos.splice(i, 1); desenharPreviews(); } }),
        ]));
      });
      inputFotos.disabled = fotos.length >= 5;
    }
    var inputFotos = el('input', {
      type: 'file', accept: 'image/*', multiple: true, class: 'hubff-rv-form__file', id: 'hubff-rv-fotos-' + produtoId,
      onchange: function () {
        var novos = Array.prototype.slice.call(inputFotos.files || []).slice(0, 5 - fotos.length);
        inputFotos.value = '';
        Promise.all(novos.map(reduzir)).then(function (r) { fotos = fotos.concat(r).slice(0, 5); desenharPreviews(); });
      },
    });
    var notas = el('div', { class: 'hubff-rv-form__stars', role: 'radiogroup', 'aria-label': 'Sua nota' }, [5, 4, 3, 2, 1].map(function (n) {
      var id = 'hubff-rv-n' + n + '-' + produtoId;
      return el('span', {}, [el('input', { type: 'radio', name: 'nota', value: n, id: id, required: true }), el('label', { for: id, title: n + ' estrela' + (n > 1 ? 's' : ''), text: '★' })]);
    }));
    var campo = function (rotulo, controle, dica) { return el('label', { class: 'hubff-rv-form__campo' }, [el('span', { text: rotulo }), controle, dica ? el('small', { text: dica }) : null]); };
    var selTamanho = tamanhos.length ? el('select', { name: 'tamanho' }, [el('option', { value: '', text: 'Selecione' })].concat(tamanhos.map(function (t) { return el('option', { value: t, text: t }); }))) : null;
    var caimento = el('div', { class: 'hubff-rv-form__fit', role: 'radiogroup', 'aria-label': 'Como serviu' }, ['pequeno', 'ideal', 'grande'].map(function (k) {
      var id = 'hubff-rv-fit-' + k + '-' + produtoId;
      return el('span', {}, [el('input', { type: 'radio', name: 'caimento', value: k, id: id }), el('label', { for: id, text: CAIMENTO[k] })]);
    }));
    var enviar = el('button', { type: 'submit', class: 'button button--filled hubff-rv-form__enviar', text: 'Enviar avaliação' });
    var form = el('form', { class: 'hubff-rv-form', novalidate: true }, [
      el('p', { class: 'hubff-rv-form__produto', text: produtoTitulo }),
      el('div', { class: 'hubff-rv-form__campo' }, [el('span', { text: 'Sua nota *' }), notas]),
      campo('Título', el('input', { type: 'text', name: 'titulo', maxlength: 120, placeholder: 'Resuma em uma frase' })),
      campo('Sua avaliação *', el('textarea', { name: 'texto', rows: 4, minlength: 10, maxlength: 3000, required: true, placeholder: 'O que achou do tecido, do caimento, da cor…' })),
      el('div', { class: 'hubff-rv-form__linha' }, [
        selTamanho ? campo('Tamanho que você comprou', selTamanho) : null,
        el('div', { class: 'hubff-rv-form__campo' }, [el('span', { text: 'Como serviu' }), caimento]),
      ]),
      el('div', { class: 'hubff-rv-form__campo' }, [
        el('span', { text: 'Fotos (até 5)' }),
        el('label', { class: 'hubff-rv-form__upload', for: inputFotos.id, text: '+ Adicionar fotos' }), inputFotos, previews,
      ]),
      CLI ? el('p', { class: 'hubff-rv-form__conta', text: 'Enviando como ' + (CLI.n || CLI.e) + '.' }) : null,
      CLI && CLI.n ? null : campo('Seu nome *', el('input', { type: 'text', name: 'nome', maxlength: 80, required: true, autocomplete: 'given-name' }), 'Aparece só o primeiro nome e a inicial do sobrenome.'),
      CLI ? null : campo('Seu e-mail *', el('input', { type: 'email', name: 'email', maxlength: 200, required: true, autocomplete: 'email' }), 'Não aparece no site.'),
      el('input', { type: 'text', name: 'site', class: 'hubff-hp', tabindex: '-1', autocomplete: 'off', 'aria-hidden': 'true' }),
      el('label', { class: 'hubff-rv-form__consent' }, [el('input', { type: 'checkbox', name: 'consentimento', value: '1', required: true }), el('span', { text: 'Autorizo a Fio a Fio a publicar minha avaliação e minhas fotos no site.' })]),
      erro, enviar,
    ]);
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      erro.textContent = '';
      var fd = new FormData(form);
      if (!fd.get('nota')) { erro.textContent = 'Escolha de 1 a 5 estrelas.'; return; }
      if (String(fd.get('texto') || '').trim().length < 10) { erro.textContent = 'Conte um pouco mais (pelo menos 10 letras).'; return; }
      if (!CLI && String(fd.get('nome') || '').trim().length < 2) { erro.textContent = 'Informe seu nome.'; return; }
      if (!CLI && !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(String(fd.get('email') || '').trim())) { erro.textContent = 'Informe um e-mail válido.'; return; }
      if (!fd.get('consentimento')) { erro.textContent = 'Marque a autorização pra publicar.'; return; }
      fd.append('loja', LOJA); fd.append('produto', produtoId);
      if (CLI) { fd.append('c', CLI.c); fd.append('e', CLI.e); fd.append('t', CLI.t); if (CLI.n && !fd.get('nome')) fd.append('nome', CLI.n); }
      fotos.forEach(function (f) { fd.append('fotos', f, f.name || 'foto.jpg'); });
      enviar.disabled = true; enviar.textContent = 'Enviando…';
      fetch(API + '/reviews', { method: 'POST', body: fd })
        .then(function (r) { return r.json().catch(function () { return {}; }).then(function (j) { if (!r.ok) throw new Error(j.error || 'Não deu pra enviar agora.'); return j; }); })
        .then(function (j) { aoEnviar(j.mensagem || 'Recebemos sua avaliação!'); })
        .catch(function (err) { erro.textContent = err.message; enviar.disabled = false; enviar.textContent = 'Enviar avaliação'; });
    });
    return form;
  }

  function abrirFormulario(root) {
    var produtoId = root.getAttribute('data-produto');
    var titulo = root.getAttribute('data-titulo') || '';
    // A ordem do cadastro varia (XG, PP, GG…): grade de letras primeiro, depois números.
    var GRADE = ['PP', 'P', 'M', 'G', 'GG', 'XG', 'XGG', 'EG', 'EGG', 'U'];
    var peso = function (t) { var i = GRADE.indexOf(t.toUpperCase()); return i >= 0 ? i : /^\d+$/.test(t) ? 100 + Number(t) : 1000; };
    var tamanhos = (root.getAttribute('data-tamanhos') || '').split('|').filter(Boolean)
      .sort(function (a, b) { return peso(a) - peso(b) || a.localeCompare(b); });
    var caixa = el('div', { class: 'hubff-rv-modal__box' });
    function fechar() { ov.remove(); document.removeEventListener('keydown', tecla); document.documentElement.classList.remove('hubff-no-scroll'); }
    function tecla(e) { if (e.key === 'Escape') fechar(); }
    var ov = el('div', { class: 'hubff-rv-modal', role: 'dialog', 'aria-modal': 'true', 'aria-label': 'Escrever avaliação', onclick: function (e) { if (e.target === ov) fechar(); } }, [caixa]);
    caixa.appendChild(el('button', { type: 'button', class: 'hubff-rv-modal__close', 'aria-label': 'Fechar', text: '×', onclick: fechar }));
    caixa.appendChild(el('h2', { class: 'h4 hubff-rv-modal__titulo', text: 'Escrever avaliação' }));
    caixa.appendChild(formulario(root, produtoId, titulo, tamanhos, function (mensagem) {
      caixa.querySelector('form').remove();
      caixa.appendChild(el('div', { class: 'hubff-rv-modal__ok' }, [
        el('p', { class: 'h4', text: 'Obrigada!' }), el('p', { text: mensagem }),
        el('button', { type: 'button', class: 'button button--outlined', text: 'Fechar', onclick: fechar }),
      ]));
    }));
    document.body.appendChild(ov); document.documentElement.classList.add('hubff-no-scroll');
    document.addEventListener('keydown', tecla);
    var primeiro = caixa.querySelector('input[name="nota"]'); if (primeiro) primeiro.focus();
  }

  function secaoAvaliacoes(root) {
    var produtoId = root.getAttribute('data-produto');
    var alvo = root.querySelector('[data-hubff-rv-lista]');
    var estado = { pagina: 1, ordem: 'recentes' };
    root.querySelectorAll('[data-hubff-rv-abrir]').forEach(function (b) { b.addEventListener('click', function () { abrirFormulario(root); }); });
    if (location.hash === '#avaliar') abrirFormulario(root);

    var corpo = el('div', { class: 'hubff-rv-corpo' });
    var lista = el('div', { class: 'hubff-rv-lista' });
    var mais = el('button', { type: 'button', class: 'button button--outlined hubff-rv-mais', text: 'Ver mais avaliações', hidden: true, onclick: function () { estado.pagina++; carregar(true); } });
    var ordem = el('select', { class: 'hubff-rv-ordem', 'aria-label': 'Ordenar avaliações', onchange: function () { estado.ordem = ordem.value; estado.pagina = 1; carregar(false); } }, [
      el('option', { value: 'recentes', text: 'Mais recentes' }), el('option', { value: 'fotos', text: 'Com fotos' }),
      el('option', { value: 'melhores', text: 'Melhores notas' }), el('option', { value: 'piores', text: 'Piores notas' }),
    ]);
    var montado = false;

    function carregar(acrescentar) {
      mais.disabled = true;
      fetch(API + '/reviews?' + qs({ loja: LOJA, produto: produtoId, pagina: estado.pagina, ordem: estado.ordem }))
        .then(function (r) { if (!r.ok) throw new Error(String(r.status)); return r.json(); })
        .then(function (d) {
          if (!montado) {
            montado = true;
            if (!d.resumo.total) {
              alvo.appendChild(el('p', { class: 'hubff-rv-vazio', text: 'Ainda não há avaliações deste produto. Conte o que achou!' }));
              return;
            }
            corpo.appendChild(resumoAvaliacoes(d.resumo));
            if (d.galeria && d.galeria.length) {
              corpo.appendChild(el('div', { class: 'hubff-rv-galeria' }, [el('p', { class: 'hubff-rv-galeria__titulo', text: 'Fotos das clientes' }), miniaturas(d.galeria, 'hubff-rv-galeria__fotos')]));
            }
            corpo.appendChild(el('div', { class: 'hubff-rv-toolbar' }, [el('span', { text: d.resumo.total + (d.resumo.total === 1 ? ' avaliação' : ' avaliações') }), ordem]));
            corpo.appendChild(lista); corpo.appendChild(mais);
            alvo.appendChild(corpo);
          }
          if (!acrescentar) lista.textContent = '';
          if (!d.avaliacoes.length && !acrescentar) lista.appendChild(el('p', { class: 'hubff-rv-vazio', text: 'Nenhuma avaliação com fotos ainda.' }));
          d.avaliacoes.forEach(function (a) { lista.appendChild(itemAvaliacao(a)); });
          mais.hidden = d.pagina >= d.totalPaginas;
          mais.disabled = false;
        })
        .catch(function () { mais.disabled = false; });
    }
    carregar(false);
  }

  // ─── início ───────────────────────────────────────────────────────────────
  function iniciar() {
    iniciarWishlist();
    document.querySelectorAll('[data-hubff-wl-page]').forEach(paginaFavoritos);
    document.querySelectorAll('[data-hubff-reviews]').forEach(secaoAvaliacoes);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
})();
